/**
 * Client HTTP dùng chung cho toàn bộ frontend (axios).
 *
 * Cấu hình base URL từ biến môi trường, gắn Bearer token từ localStorage
 * vào mọi request, và xóa token khi API trả 401 (hết phiên).
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/** Instance axios đã cấu hình sẵn base URL và header JSON. */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor request: đính kèm JWT nếu user đã đăng nhập
apiClient.interceptors.request.use((requestConfig) => {
  const authToken = localStorage.getItem('token');

  if (authToken) {
    requestConfig.headers.Authorization = `Bearer ${authToken}`;
  }

  return requestConfig;
});

// Interceptor response: dọn token khi unauthorized
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
    }

    return Promise.reject(error);
  }
);
